export default {
    localhost: {
        url: 'http://localhost/api-isikulkas/public/',
        upload_path: 'http://localhost/api-isikulkas/upload/'
    },
    server: {
        url: 'https://api.isikulkas.co.id/api-isikulkas/public/',
        upload_path: 'https://api.isikulkas.co.id/attachment/'
    }

}